import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class LeadLostPiechart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [28.6, 57.1, 14.3],
      options: {
        labels: ["Commision rate", "No Contact", "Another agent"],
        colors:['#8c52ff', '#cb6ce6','#7ed957'],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
       
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default LeadLostPiechart
